{
  "title": "Help & Support",
  "description": "Customer issues and platform support requests",
  "tabs": {
    "customerIssues": "Customer issues",
    "contact": "Get help"
  },
  "searchPlaceholder": "Search tickets...",
  "emptyTitle": "No customer issues",
  "emptyDescription": "Customer issues about appointments will appear here.",
  "contact": {
    "title": "Contact ForumOne",
    "description": "Submit a support request and our team will get back to you.",
    "categoryLabel": "Category",
    "categoryPlaceholder": "Select a category",
    "subjectLabel": "Subject",
    "subjectPlaceholder": "Brief summary of your issue",
    "messageLabel": "Message",
    "messagePlaceholder": "Describe your issue in detail",
    "submit": "Submit request",
    "success": "Support request submitted",
    "error": "Failed to submit request"
  },
  "columns": {
    "ticketId": "Ticket ID",
    "customer": "Customer",
    "service": "Service",
    "status": "Status",
    "category": "Category"
  },
  "status": {
    "all": "All",
    "pending": "Pending",
    "inReview": "In review",
    "refunded": "Refunded",
    "rejected": "Rejected",
    "resolved": "Resolved",
    "cancelled": "Cancelled"
  },
  "categories": {
    "APPOINTMENT_DISPUTE": "Appointment dispute",
    "BOOKING": "Booking or scheduling",
    "PAYMENT": "Payment or charge",
    "PAYOUT": "Payout or bank details",
    "SUBSCRIPTION": "Plan or subscription",
    "ACCOUNT": "Account or access",
    "TECHNICAL": "Technical issue",
    "GENERAL": "Something else"
  },
  "modal": {
    "customer": "Customer",
    "provider": "Provider",
    "noProvider": "No provider",
    "noProviderEmail": "No provider email"
  },
  "adminTabs": {
    "disputes": "Disputes",
    "payments": "Payments & payouts",
    "bookings": "Bookings",
    "accountTech": "Account & technical",
    "general": "General",
    "all": "All"
  },
  "admin": {
    "status": "Status",
    "message": "Message",
    "replyLabel": "Reply to customer",
    "replyPlaceholder": "Write a reply…",
    "sendReply": "Send reply",
    "reject": "Reject",
    "approveRefund": "Approve refund",
    "markResolved": "Mark resolved",
    "resolveSuccess": "Ticket updated",
    "resolveError": "Failed to update ticket",
    "replySuccess": "Reply sent",
    "replyError": "Failed to send reply"
  }
}
